import { create } from 'zustand';

type prevUrlStore = {
  prevUrl: string | undefined;
  setPrevUrl: (prevUrl: string) => void;
  navDepth: number;
  pushNav: () => void;
  popNav: () => void;
};

export const usePrevUrlStore = create<prevUrlStore>((set) => ({
  prevUrl: undefined,
  setPrevUrl(prevUrl) {
    set({ prevUrl });
  },
  navDepth: 0,
  pushNav: () => set((s) => ({ navDepth: s.navDepth + 1 })),
  popNav: () => set((s) => ({ navDepth: Math.max(0, s.navDepth - 1) })),
}));
